import React, { Fragment, useState } from 'react';
import { Button, Dialog, DialogContent, DialogTitle, DialogActions } from '@material-ui/core';
import { Field, Formik } from 'formik';
import * as Yup from 'yup';

import { GQLPlatformSaleCatalog, GQLParty } from '@jewelutions/core-crm-server-api-client-domain';
import { ErrorComponent, JwlField, LoadingSpinner } from '../../../../components';
import { GQLOperationBuilder } from '../../../../operations/GQLOperationBuilder';

interface IProps {
  sourcePlatformSaleCatalog: GQLPlatformSaleCatalog;
  onClose: (success: boolean, newPlatformSaleCatalogId: string) => void;
}

export const PlatformSaleCatalogDuplicateDialog: React.FC<IProps> = ({
  sourcePlatformSaleCatalog,
  onClose
}: IProps) => {
  const [errorComponentState, setErrorComponentState] = useState(false);
  const [platformSaleCatalogToPersist, setPlatformSaleCatalogToPersist] = useState(null as any);
  const initialValues = {
    name: sourcePlatformSaleCatalog.name.en,
    description: sourcePlatformSaleCatalog.description.en
  };

  const [
    duplicatePlatformSaleCatalog,
    { error: errorDuplicatePlatformSaleCatalog, loading: createDuplicatePlatformSaleCatalogLoader }
  ] = GQLOperationBuilder.platformSaleCatalog.createFromPlatformSaleCatalog();

  const onSubmit = (props: any) => {
    const mutationVariables = {
      name: { en: props.name },
      description: { en: props.description },
      platformSaleCatalogId: sourcePlatformSaleCatalog.id
    };

    setPlatformSaleCatalogToPersist(props);
    duplicatePlatformSaleCatalog({ variables: mutationVariables }).then(response => {
      onClose(true, GQLOperationBuilder.platformSaleCatalog.platformSaleCatalogIdFromResponse(response.data));
    });
  };

  if (errorDuplicatePlatformSaleCatalog && !errorComponentState)
    return (
      <Dialog open={true} maxWidth="md" aria-labelledby="duplicate-platform-sale-catalog">
        <ErrorComponent
          margins="0"
          close={setErrorComponentState}
          callback={() => onSubmit(platformSaleCatalogToPersist)}
          details={errorDuplicatePlatformSaleCatalog?.stack}
          message={errorDuplicatePlatformSaleCatalog?.message}
        />
      </Dialog>
    );

  if (createDuplicatePlatformSaleCatalogLoader) return <LoadingSpinner />;

  const validationSchema = Yup.object().shape({
    name: Yup.string().required('Name is required'),
    description: Yup.string().required('Description is required')
  });

  return (
    <Dialog open={true} aria-labelledby="duplicate-platform-sale-catalog">
      <Fragment>
        <DialogTitle>Duplicate platform sale catalog</DialogTitle>
        <DialogContent>
          <Formik
            initialValues={{ ...initialValues }}
            validationSchema={validationSchema}
            onSubmit={onSubmit}
          >
            {({ values, touched, handleSubmit }) => (
              <form onSubmit={handleSubmit}>
                <Field name="name" component={JwlField} label="Name" />
                <Field name="description" component={JwlField} label="Description" />

                <DialogActions>
                  <Button color="primary" onClick={() => onClose(false, '')}>
                    Close
                  </Button>
                  <Button type="submit" color="primary" variant="contained">
                    Save
                  </Button>
                </DialogActions>
              </form>
            )}
          </Formik>
        </DialogContent>
      </Fragment>
    </Dialog>
  );
};

export default PlatformSaleCatalogDuplicateDialog;
